import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { toAletheiaItem } from './aletheiaItemFallback'
import { type DniAnalysisTransformer } from './transformers'

export const viewItemListTransformer: DniAnalysisTransformer = (platform, event) => {
  if (event.eventName !== 'view_item_list') return event
  if (platform === AnalyticsPlatforms.ALETHEIA) {
    return {
      eventName: 'view_item_list',
      eventParams: {
        ...event.eventParams,
        items: event.eventParams.items?.map(item => toAletheiaItem(item, 'view_item_list')),
      },
    }
  }
  return event
}
